// extracted by mini-css-extract-plugin
export default {"root":"Controls-root_LZeeE","close":"Controls-close_VVfl_","gandi":"Controls-gandi_ovFWo","logo":"Controls-logo_bxPpb"};